import React from "react";
import { useHistory, useParams } from "react-router-dom";

import { Typography } from "antd";

import allTabs from "containers/Enterprise/enterpriseEarnings/tabs";
import SessionClient from "util/SessionClient";
import styles from "components/PlatformLayout/components/PlatformPageHeader/PlatformPageHeader.module.less";

const { Title } = Typography;

const session = new SessionClient();

const EnterpriseEarningsBreadCrumbs = () => {
  const params = useParams();
  const history = useHistory();

  const enterpriseName = session?.user?.props?.enterpriseName || "";
  const activeTab = allTabs.find((t) => t.key === params.tab);

  const handleBaseNavigate = () => {
    history.push("/org-earnings");
  };

  const baseStyle = {
    cursor: "pointer",
    textTransform: "capitalize",
    fontWeight: 600,
  };

  return (
    <>
      <Title className={styles.title} style={baseStyle} onClick={handleBaseNavigate}>
        {enterpriseName} Earnings
      </Title>
      {activeTab && (
        <>
          <span className={styles.titleSeparator}>/</span>
          <Title className={styles.titleSecondary}>{activeTab.label}</Title>
        </>
      )}
    </>
  );
};

export default EnterpriseEarningsBreadCrumbs;
